import { render, staticRenderFns } from "./CommodityHotSaleList.vue?vue&type=template&id=abb183b2&scoped=true"
import script from "./CommodityHotSaleList.vue?vue&type=script&lang=js"
export * from "./CommodityHotSaleList.vue?vue&type=script&lang=js"
import style0 from "./CommodityHotSaleList.vue?vue&type=style&index=0&id=abb183b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb183b2",
  null
  
)

export default component.exports